import { ProductCard } from "@kohler-dsm-library/kohler-core"
import productCardHOC from "@/components/ProductList/v3/ProductCardHOC"

const ProductCardUI = props => {
  return <ProductCard {...props} />
}

export default productCardHOC(ProductCardUI)
